/**
 * 交付等状況出力報告書
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/reports/issuance_statuses`

const report_issuance_status = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    create({ commit }, { conditions }) {
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH, conditions).then(data => {
          commit('snackbar/showInfo', { message: '出力処理を受け付けました。' }, { root: true })
          resolve(data)
        })
      })
    }
  },
  mutations: {
  },
}

export default report_issuance_status
